import { render } from "./radio.vue?vue&type=template&id=6b71846b"
import script from "./radio.vue?vue&type=script&lang=js"
export * from "./radio.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/components/form/horizontal/radio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b71846b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b71846b', __exports__)) {
    console.log('reload')
    api.reload('6b71846b', __exports__)
  }
  
  module.hot.accept("./radio.vue?vue&type=template&id=6b71846b", () => {
    console.log('re-render')
    api.rerender('6b71846b', render)
  })

}


export default __exports__